<script setup lang="ts">
import { DateTime } from 'luxon'

import { type Travel, TravelReasonEnum } from '~/layers/forms/models'

interface Props {
  model: Travel
}
const props = defineProps<Props>()

const data = computed(() => [
  {
    label: 'Fecha de partida',
    value: props.model.from ? DateTime.fromJSDate(props.model.from).toISODate() : null,
  },
  {
    label: 'Fecha de partida',
    value: props.model.to ? DateTime.fromJSDate(props.model.to).toISODate() : null,
  },
  {
    label: 'Motivo',
    value: props.model.reason ? TravelReasonEnum[props.model.reason].label : null,
  },
  {
    label: 'Duración',
    value: props.model.calculatedDays ? `${props.model.calculatedDays} días` : null,
  },
])
</script>

<template>
  <FormsGlobalResume
    type="Destino"
    :name="model.destination?.name"
    :data
    hint-text="Información del viaje"
  />
</template>
